import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cfaa4d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-dashboard" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "售后服务数据")
], -1))
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = {
  key: 0,
  class: "chart-container bar-chart"
}
const _hoisted_5 = {
  key: 1,
  class: "pie-section"
}
const _hoisted_6 = { class: "pie-charts-container" }
const _hoisted_7 = { class: "pie-chart-item" }
const _hoisted_8 = { style: {"text-align":"right"} }
const _hoisted_9 = { class: "dialog-footer" }

import { ref, onMounted, nextTick,computed } from 'vue'
import { getListData,createData,queryStatistical,getPageListData,downloadData} from '@/service/main/system'
import * as echarts from 'echarts'
import { useStore } from '@/store'
import { ElLoading,ElInput, ElButton, ElMessage, ElMessageBox } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()

// 判断是否为超级管理员角色
const isADMIN = computed(() => {
  const roles = store.state.login.userInfo.roles
  if (roles && roles.length > 0) {
    return roles.find((role: any) => role.roleName === 'ROLE_ADMIN') ? true : false
  } else {
    return false
  }
})
// 判断是否为经理角色
const isSHM = computed(() => {
  const roles = store.state.login.userInfo.roles
  if (roles && roles.length > 0) {
    return roles.find((role: any) => role.roleName === 'ROLE_SHM') ? true : false
  } else {
    return false
  }
})
// 判断是否为组长角色
const isSHG = computed(() => {
  const roles = store.state.login.userInfo.roles
  if (roles && roles.length > 0) {
    return roles.find((role: any) => role.roleName === 'ROLE_SHG') ? true : false
  } else {
    return false
  }
})
// 判断是否为助理角色
const isSHA = computed(() => {
  const roles = store.state.login.userInfo.roles
  if (roles && roles.length > 0) {
    return roles.find((role: any) => role.roleName === 'ROLE_SHA') ? true : false
  } else {
    return false
  }
})
// ==================== 列表 ====================
const tableData = ref<any>([])
async function getList() {
  let list = await getListData('/shHome/getFormData',{})
  if (list && list.length > 0) {
    tableData.value = list
    console.log(list)
  }
}

// ==================== 图表引用 ====================
const barChartRef = ref<HTMLElement>()
// const simPieRef = ref<HTMLElement>()
// const livePieRef = ref<HTMLElement>()
// const communityPieRef = ref<HTMLElement>()
const pieRef = ref<HTMLElement>() // 合并后的饼图
  
let barChart: echarts.ECharts | null = null
let pieChart: echarts.ECharts | null = null // 合并后的饼图实例
// let simPieChart: echarts.ECharts | null = null
// let livePieChart: echarts.ECharts | null = null
// let communityPieChart: echarts.ECharts | null = null

// Tab激活项
const activeTab = ref('community')

// ==================== 详情弹窗 ====================
const detailVisible = ref(false)
const detailData = ref<any>({})
const currentRow=ref<any>({})
const handleDetail = async (row: any) => {
  currentRow.value=row
let list = await getListData('/shHome/getFormHistoryData',{adminId:row.adminId})
  detailData.value = list || []
  detailVisible.value = true
}
// ==================== 详情编辑 ====================
const editVisible = ref(false)
const form = ref<any>({})
const editDetail = (row: any) => {
    form.value = row
    editVisible.value = true
}
const handleSave = async () => { 
  let obj = {
    id:form.value.id,
    fundOpenCount:form.value.fundOpenCount,
    interviewVideoCount:form.value.interviewVideoCount,
    outUserCount:form.value.outUserCount,
    renewAmount:form.value.renewAmount
  }
 createData('/shHome/updateFormData',obj).then(res=> { 
    editVisible.value = false
    handleDetail({adminId:form.value.adminId})
    getList()
 })
}

// 导出
const handleExport = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据下载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  })

  try {
    const res = await downloadData('/shHome/download', null, 'blob')
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = `售后服务数据_${new Date().getTime()}.xlsx`
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
    ElMessage.success('下载成功')
  } catch (error) {
    console.error('下载失败:', error)
    ElMessage.error('下载失败，请重试')
  } finally {
    loadingInstance.close()
  }
}
// 助理导出
const handleExportAdminId = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据下载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  })

  try {
    const res = await downloadData('/shHome/downloadByAdminId', {adminId:currentRow.value.adminId}, 'blob')
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = `售后服务助理数据_${new Date().getTime()}.xlsx`
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
    ElMessage.success('下载成功')
  } catch (error) {
    console.error('下载失败:', error)
    ElMessage.error('下载失败，请重试')
  } finally {
    loadingInstance.close()
  }
}
// ==================== Tab切换 单柱状图 ====================
const barData=ref<any>([])
const initBarChart = async () => {
  if (!barChartRef.value) return
  let list = await queryStatistical('/shHome/getBarChartData',{})
  barData.value = list || []
  barChart = echarts.init(barChartRef.value)
  switchBarChart()
}

// 切换图表数据
const switchBarChart = () => {
  if (!barChart) return
  barChart?.resize();
  const names = barData.value.map((item:any) => item.empName)
  const showDataZoom = names.length > 12
  let seriesData = []
  let color = ''
  let yName = ''

  switch (activeTab.value) {
    case 'community':
      seriesData = barData.value.map((item:any) => item.useCommunityCount)
      color = '#5470c6'
      yName = '社区使用人数'
      break
    case 'live':
      seriesData = barData.value.map((item:any) => item.liveWatchCount)
      color = '#91cc75'
      yName = '直播观看人数'
      break
    case 'sim':
      seriesData = barData.value.map((item:any) => item.useSimulateCount)
      color = '#fac858'
      yName = '模拟盘客户数量'
      break
    case 'phone':
      seriesData = barData.value.map((item:any) => item.beforeSixCallMin)
      color = '#ee6666'
      yName = '六点前电话量'
      break
    case 'phone2':
      seriesData = barData.value.map((item:any) => item.afterSixCallMin)
      color = '#764ba2'
      yName = '六点后电话量'
      break
  }

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '19%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: names,
      axisLabel: {
        interval: 0, // 强制显示所有标签（不隐藏）
        rotate: 0,    // 文字不旋转
        fontSize: 12
      },
      // 开启横向滚动条
      axisPointer: {
        type: 'shadow'
      }
    },
    // 👇 必须加这个！dataZoom 横向缩放/滚动
    dataZoom:showDataZoom ?  [
      {
        type: 'slider',    // 底部带滚动条
        xAxisIndex: [0],   // 绑定 X 轴
        start: 0,          // 起始位置 0%
        end: 40,           // 初始显示 20% 的数据（可改）
        height: 10,        // 滚动条高度
      },
      {
        type: 'inside',    // 支持鼠标滚轮/拖拽滑动
        xAxisIndex: [0]
      }
    ] : [],
    yAxis: {
      type: 'value',
      name: yName
    },
    series: [
      {
        type: 'bar',
        data: seriesData,
        itemStyle: { color }
      }
    ]
  }
  barChart.setOption(option)
}

// ==================== 环形图（独立固定数据） ====================
const initPieCharts =async () => {
  if (!pieRef.value) return
  let res = await queryStatistical('/shHome/getPieChartData', {})
  const data = res?.[0] || {} // 只有一条数据
   pieChart = echarts.init(pieRef.value)
  pieChart.setOption({
    tooltip: { trigger: 'item' },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    series: [
      {
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: true,
          position: 'outside',
          formatter: '{b}: {c}'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            fontWeight: 'bold'
          }
        },
        // 👇 核心：把三个字段拼成一组数据
        data: [
          {
            name: '直播观看人数',
            value: data.liveWatchCount || 0,
            itemStyle: { color: '#91cc75' }
          },
          {
            name: '社区客户数量',
            value: data.useCommunityCount || 0,
            itemStyle: { color: '#5470c6' }
          },
          {
            name: '模拟盘客户数量',
            value: data.useSimulateCount || 0,
            itemStyle: { color: '#fac858' }
          }
        ]
      }
    ]
  })
  // 模拟盘环形图
  // if (simPieRef.value) {
  //   simPieChart = echarts.init(simPieRef.value)
  //   simPieChart.setOption({
  //     tooltip: { trigger: 'item' },
  //     series: [{
  //       type: 'pie',
  //       radius: ['40%', '70%'],
  //       avoidLabelOverlap: false,
  //       itemStyle: {
  //         borderRadius: 10,
  //         borderColor: '#fff',
  //         borderWidth: 2
  //       },
  //       label: {
  //         show: true,
  //         position: 'outside',
  //         formatter: '{b}: {c}'
  //       },
  //       emphasis: {
  //         label: {
  //           show: true,
  //           fontSize: 14,
  //           fontWeight: 'bold'
  //         }
  //       },
  //       data: list.map((item:any) => ({
  //         value: item.useSimulateCount,
  //         name: item.empName
  //       }))
  //     }]
  //   })
  // }

  // 直播环形图
  // if (livePieRef.value) {
  //   livePieChart = echarts.init(livePieRef.value)
  //   livePieChart.setOption({
  //     tooltip: { trigger: 'item' },
  //     series: [{
  //       type: 'pie',
  //       radius: ['40%', '70%'],
  //       avoidLabelOverlap: false,
  //       itemStyle: {
  //         borderRadius: 10,
  //         borderColor: '#fff',
  //         borderWidth: 2
  //       },
  //       label: {
  //         show: true,
  //         position: 'outside',
  //         formatter: '{b}: {c}'
  //       },
  //       emphasis: {
  //         label: {
  //           show: true,
  //           fontSize: 14,
  //           fontWeight: 'bold'
  //         }
  //       },
  //       data: list.map((item:any) => ({
  //         value: item.liveWatchCount,
  //         name: item.empName
  //       }))
  //     }]
  //   })
  // }

  // 社区环形图
  // if (communityPieRef.value) {
  //   communityPieChart = echarts.init(communityPieRef.value)
  //   communityPieChart.setOption({
  //     tooltip: { trigger: 'item' },
  //     series: [{
  //       type: 'pie',
  //       radius: ['40%', '70%'],
  //       avoidLabelOverlap: false,
  //       itemStyle: {
  //         borderRadius: 10,
  //         borderColor: '#fff',
  //         borderWidth: 2
  //       },
  //       label: {
  //         show: true,
  //         position: 'outside',
  //         formatter: '{b}: {c}'
  //       },
  //       emphasis: {
  //         label: {
  //           show: true,
  //           fontSize: 14,
  //           fontWeight: 'bold'
  //         }
  //       },
  //       data: list.map((item:any) => ({
  //         value: item.useCommunityCount,
  //         name: item.empName
  //       }))
  //     }]
  //   })
  // }
}

// ==================== 窗口自适应 ====================
const handleResize = () => {
  if(barChartRef.value){
    barChart?.resize()
  }
  if(pieRef.value){
    pieChart?.resize()
  }
  // simPieChart?.resize()
  // livePieChart?.resize()
  // communityPieChart?.resize()
}

// ==================== 生命周期 ====================
onMounted(async () => {
  await getList(); // 先等表格数据请求完成
  await nextTick(); // 表格DOM挂载
  // 再延迟一帧等待flex布局完成（解决flex重排延迟）
  setTimeout(async()=>{
    if(isSHA.value && !isSHM.value && !isSHG.value && !isADMIN.value){
        initPieCharts()
    }
    if(isSHM.value || isSHG.value || isADMIN.value){
      initBarChart()
    }
  },50)
  window.addEventListener('resize', handleResize)
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (isSHM.value)
        ? (_openBlock(), _createBlock(_unref(ElButton), {
            key: 0,
            type: "primary",
            size: "medium",
            onClick: handleExport,
            style: {"margin-bottom":"10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("数据导出")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table, {
        data: tableData.value,
        style: {"width":"100%"},
        "max-height": "300",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "empName",
            label: "助理姓名",
            width: "120",
            fixed: ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "duringUserCount",
            label: "在期客户数",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "monthNewCount",
            label: "当月新单数",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            label: "直播",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "liveWatchCount",
                label: "观看人数",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "liveWatchRate",
                label: "比例",
                width: "120",
                align: "center"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "社区",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "useCommunityCount",
                label: "社区使用客户数",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "useCommunityRate",
                label: "比例",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "beforeUseCommunityRate",
                label: "前一天比例",
                width: "120",
                align: "center"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "模拟盘",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "useSimulateCount",
                label: "客户数",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "useSimulateRate",
                label: "比例",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "monthSimulateFourCount",
                label: "当月四次客户数",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "monthSimulateFourRate",
                label: "比例",
                width: "120",
                align: "center"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "电话量",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "beforeSixCallMin",
                label: "六点前",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "davBeforeSixCallMin",
                label: "日均",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "afterSixCallMin",
                label: "六点后",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "davAfterSixCallMin",
                label: "日均",
                width: "120",
                align: "center"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "averageAddPoints",
            label: "平均新增金币",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            label: "PC",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "pcLoginCount",
                label: "登录数",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "pcLoginRate",
                label: "比例",
                width: "120",
                align: "center"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "APP",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "appLoginCount",
                label: "登录数",
                width: "120",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "appLoginRate",
                label: "比例",
                width: "120",
                align: "center"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "outUserCount",
            label: "转出客户数",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "fundOpenCount",
            label: "基金开户数",
            width: "110"
          }),
          _createVNode(_component_el_table_column, {
            prop: "interviewVideoCount",
            label: "采访视频数",
            width: "110"
          }),
          _createVNode(_component_el_table_column, {
            prop: "renewAmount",
            label: "续费金额",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "80",
            fixed: "right",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(ElButton), {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (handleDetail(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("详情")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    (isSHM.value || isSHG.value || isADMIN.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_tabs, {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
            onTabClick: switchBarChart,
            class: "chart-tabs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "社区",
                name: "community"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "直播",
                name: "live"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "模拟盘",
                name: "sim"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "六点前电话量",
                name: "phone"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "六点后电话量",
                name: "phone2"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", {
            ref_key: "barChartRef",
            ref: barChartRef,
            class: "chart"
          }, null, 512)
        ]))
      : _createCommentVNode("", true),
    (isSHA.value && !isSHM.value && !isSHG.value && !isADMIN.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", null, _toDisplayString(tableData.value?.[0]?.empName ?? '数据统计'), 1),
              _createElementVNode("div", {
                ref_key: "pieRef",
                ref: pieRef,
                class: "chart"
              }, null, 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((detailVisible).value = $event)),
      title: "月历史数据",
      width: "85vw"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            size: "medium",
            onClick: handleExportAdminId
          }, {
            default: _withCtx(() => [
              _createTextVNode("数据导出")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_table, {
          data: detailData.value,
          style: {"width":"100%","margin":"20px 10px"},
          "max-height": "300",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "empName",
              label: "助理姓名",
              width: "120",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "duringUserCount",
              label: "在期客户数",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "monthNewCount",
              label: "当月新单数",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "直播",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "liveWatchCount",
                  label: "观看人数",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "liveWatchRate",
                  label: "比例",
                  width: "120",
                  align: "center"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "社区",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "useCommunityCount",
                  label: "社区使用客户数",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "useCommunityRate",
                  label: "比例",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "beforeUseCommunityRate",
                  label: "前一天比例",
                  width: "120",
                  align: "center"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "模拟盘",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "useSimulateCount",
                  label: "客户数",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "useSimulateRate",
                  label: "比例",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "monthSimulateFourCount",
                  label: "当月四次客户数",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "monthSimulateFourRate",
                  label: "比例",
                  width: "120",
                  align: "center"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "电话量",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "beforeSixCallMin",
                  label: "六点前",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "davBeforeSixCallMin",
                  label: "日均",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "afterSixCallMin",
                  label: "六点后",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "davAfterSixCallMin",
                  label: "日均",
                  width: "120",
                  align: "center"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "averageAddPoints",
              label: "平均新增金币",
              width: "80"
            }),
            _createVNode(_component_el_table_column, {
              label: "PC",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "pcLoginCount",
                  label: "登录数",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "pcLoginRate",
                  label: "比例",
                  width: "120",
                  align: "center"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "APP",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "appLoginCount",
                  label: "登录数",
                  width: "120",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "appLoginRate",
                  label: "比例",
                  width: "120",
                  align: "center"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "outUserCount",
              label: "转出客户数",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "fundOpenCount",
              label: "基金开户数",
              width: "110"
            }),
            _createVNode(_component_el_table_column, {
              prop: "interviewVideoCount",
              label: "采访视频数",
              width: "110"
            }),
            _createVNode(_component_el_table_column, {
              prop: "renewAmount",
              label: "续费金额",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createdTime",
              label: "创建时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "80",
              fixed: "right",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (_unref(store).state.login.userInfo.realName == scope.row.empName)
                  ? (_openBlock(), _createBlock(_unref(ElButton), {
                      key: 0,
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (editDetail(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: editVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editVisible).value = $event)),
      title: "编辑",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: handleSave
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (editVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 取消 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          modelValue: form.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form).value = $event)),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "基金开户数" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "number",
                  modelValue: form.value.fundOpenCount,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.fundOpenCount) = $event)),
                  placeholder: "请输入基金开户数"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "采访视频数量" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "number",
                  modelValue: form.value.interviewVideoCount,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.interviewVideoCount) = $event)),
                  placeholder: "请输入采访视频数量"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "转出客户数量" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "number",
                  modelValue: form.value.outUserCount,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.outUserCount) = $event)),
                  placeholder: "请输入转出客户数量"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "续费金额" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "number",
                  modelValue: form.value.renewAmount,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.renewAmount) = $event)),
                  placeholder: "请输入续费金额"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})